import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { PROVIDER } from 'src/environments/config';
import { DialogCustomComponent } from '../dialog-custom/dialog-custom.component';
import { BarcodeDialogComponent } from '../barcode-dialog/barcode-dialog.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-sidemenu',
  templateUrl: './sidemenu.component.html',
  styleUrls: ['./sidemenu.component.scss']
})
export class SidemenuComponent {

  public isCollapsed = true;
  
  _user:any = null
  obs: Subscription[] = []

  isDelivery: boolean = PROVIDER.isDelivery;
  showBarCode: boolean = PROVIDER.showBarCode;
  
  constructor(
    private authService: AuthenticationService,
    private dialog: MatDialog,
    private modalService: NgbModal,
  ) {
    this.obs.push(
      this.authService.currentUser.subscribe(res => {
        this._user = res == null ? null : res.user
      })
    )
  }

  ngOnInit(): void {
    const pathName = window.location.pathname;
    const items = Array.from(document.querySelectorAll("a.menulist"));
    let matchingMenuItem = items.find((x: any) => {
      return x.pathname === pathName;
    });
    matchingMenuItem?.classList.add('active')
  }

  openPoints(){
    const modalRef = this.modalService.open(BarcodeDialogComponent, { size: 'lg' }); // Ajusta el tamaño aquí
  }

  ngOnDestroy() {
    this.obs.forEach(element => {
      element.unsubscribe()
    });
  }
}
